// Course Finder
"use strict";
	
jQuery(document).ready(function() {
	const components = document.querySelectorAll('.cmp-flindersonline-course-finder');
	const expiryInDays = 7;

	if (components.length > 0) {
		components.forEach(component => {
			const input = component.querySelector('.aa-InputWrapper .aa-Input');
			const submit = component.querySelector('.aa-SubmitButton');
			const select = document.querySelector('.course-finder-panel .aa-Item');
			const path = component.dataset.searchResultsPath || "/";
			const syntax = component.dataset.searchResultsSyntax || "q";
			const search = component.dataset.search === 'true';
			const recent = component.dataset.recent === 'true';
			const interest = component.dataset.interest === 'true';

			if(!recent) getRecentSearches(component);

			submit?.addEventListener('submit', function (e){
				const value = input.value.trim();
				submitSearch(value);
			});

			input?.addEventListener('keypress', function(e) {
				const value = e.target.value.trim();

				if (e.keyCode === 13) { 
					submitSearch(value, component);
				}
			});

			$(document).on('keydown', '.course-finder-panel-mobile .aa-Input', function(e){
				if (e.key === 'Enter' || e.keyCode === 13) {
					const value = $(this).val().trim();
					if (value) {
						submitSearch(value, component);
					}
				}
			});

			$(document).on('click', '.course-finder-panel .aa-Item', function (e) {
				const value = $(this).find('.suggestion-title').text().trim();
				if (value) {
					submitSearch(value, component);
				}
			});

			$(document).on('click', '.course-finder-panel-mobile .aa-SubmitIcon', function(e){
				const value = $(this).closest('.course-finder-panel-mobile').find('.aa-Input').val();
				if (value) {
					submitSearch(value, component);
				}
			});
		});
	} 

	function submitSearch(value, component){
		const path = (component.dataset.searchResultsPath || '').replace(/\/+$/, '');;
		const paramName = (component.dataset.searchResultsSyntax || "q").replace(/[?&]/g, '');
		const url =  `${window.location.origin}${path}.html?${paramName}=${encodeURIComponent(value)}`;
		const finalUrl = window.Granite?.HTTP?.externalize(url) || url;


		saveWithExpiry('recent_search', value, expiryInDays);
		getRecentSearches(component);
	}

	function getRecentSearches(target) {
		const recentSearch = target.querySelector('.course-finder__recent-search');
		
		if(recentSearch) {
			const recent = JSON.parse(localStorage.getItem("recent_search")) || [];	
			const path = (target.dataset.searchResultsPath || '').replace(/\/+$/, '');;
			const paramName = (target.dataset.searchResultsSyntax || "q").replace(/[?&]/g, '');
			 		
			if(recent && recent.length > 0){
				const list = recentSearch.querySelector('.course-finder__list');
				recentSearch.classList.add('active');
				
				if(list) {
					list.innerHTML = recent
						.slice(0, 10)
						.map(item => {
							const params = new URLSearchParams();
                            params.append(paramName, item.value);
                            const finalUrl = `${!(path.startsWith('http') || path.startsWith('www')) ? window.location.origin : ''}${path}?${params.toString()}`;
							return `<div class="cf_list-item"><a href="${finalUrl}">${item.value}</a></div>`
						})
						.join("");
				}
			}
		}
	}

	function saveWithExpiry(key, value, expiryInDays) {
		// Calculate expiry date
		const expiryDate = new Date();
		expiryDate.setDate(expiryDate.getDate() + expiryInDays);
		
		// Get existing items (or initialize empty array)
		const existingItems = JSON.parse(localStorage.getItem(key)) || [];
		
		// Check for duplicates (case-sensitive)
		const isDuplicate = existingItems.some(item => 
			item.value.toLowerCase() === value.toLowerCase()
		);
		
		if (isDuplicate) {
			return false; 
		}
		
		// Create new item
		const newItem = {
			value: value,
			expiryDate: expiryDate.toISOString(),
			createdAt: new Date().toISOString() // For tracking
		};
		
		// Add new item to beginning (latest first) and keep only unexpired
		const updatedItems = [newItem, ...existingItems]
			.filter(item => new Date(item.expiryDate) > new Date()) 
			.slice(0, 10);
		
		// Save to localStorage
		localStorage.setItem(key, JSON.stringify(updatedItems));
		return true;
	}
});